import { faUsers, faVirus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import ActionBtn from "src/components/ActionBtn";
import CardContainer from "src/components/CardContainer";
import FlatIcon from "src/components/FlatIcon";
import TextInputField from "src/components/forms/TextInputField";
import Img from "src/components/Img";
import LayoutContainer from "src/components/LayoutContainer";
import ConfirmationModal from "src/components/modal/ConfirmationModal";
import TableV2 from "src/components/table/TableV2";
import useDataTable from "src/helpers/useDataTable";
import { localArraySearch } from "src/helpers/utils";
import ClinicPersonnelFormModal from "./components/ClinicPersonnelFormModal";

const PhoClinicPersonnel = () => {
	const [list, setList] = useState([]);
	const [keyword, setKeyword] = useState("");
	const clinic_personnel_form_modal = useRef(null);
	const confirm_delete_ref = useRef(null);
	const {
		data,
		loading,
		updateInList,
		addToList,
		removeFromList,
		column,
		setColumn,
		direction,
		setDirection,
		setPaginate,
	} = useDataTable("/v1/management/personnel", setList, {});
	useEffect(() => {
		setPaginate(200);
	}, []);
	useEffect(() => {
		if (data?.data) {
			setList(data?.data || []);
		}
	}, [data]);

	const deleteClinicPersonnel = (id) => {
		return axios.post(`/v1/management/personnel/${id}`, {
			_method: "DELETE",
		});
	};

	const columns = [
		{
			header: "Personnel Name",
			accessorKey: "name",
			headerClassName: "text-left min-w-[328px]",
			className: "text-left",
			sortable: true,
			cell: (data) => {
				return (
					<div className="flex items-center gap-2">
						<Img
							type="user"
							src={data?.avatar}
							name={data?.name}
							className="w-8 h-8 rounded-full bg-white"
						/>
						<span>{data?.name}</span>
					</div>
				);
			},
		},
		{
			header: "Username",
			accessorKey: "username",
			headerClassName: "text-left",
			className: "text-left",
		},
		{
			header: "Type",
			accessorKey: "type",
			headerClassName: "text-left",
			className: "text-left",
		},
		{
			header: "Region",
			accessorKey: "region",
			headerClassName: "text-left",
			className: "text-left",
			cell: (data) => {
				return data?.region || "";
			},
		},
		{
			header: "Province",
			accessorKey: "province",
			headerClassName: "text-left",
			className: "text-left",
			cell: (data) => {
				return data?.province || "";
			},
		},
		{
			header: "Municipality",
			accessorKey: "municipality",
			headerClassName: "text-left",
			className: "text-left",
			cell: (data) => {
				return data?.municipality || "";
			},
		},
		{
			header: "Barangay",
			accessorKey: "barangay",
			headerClassName: "text-left",
			className: "text-left",
			cell: (data) => {
				return data?.barangay || "";
			},
		},
		{
			header: "Purok",
			accessorKey: "purok",
			headerClassName: "text-left",
			className: "text-left",
			cell: (data) => {
				return data?.purok?.name || "";
			},
		},
		{
			header: "Action",
			accessorKey: "action",
			cell: (data) => {
				return (
					<div className="flex items-center gap-2">
						<ActionBtn
							size="sm"
							type="primary-light"
							onClick={() => {
								console.log("datadata", data);
								clinic_personnel_form_modal.current.show(data);
							}}
						>
							<FlatIcon icon="rr-edit" className="text-lg mr-2" />
							Edit
						</ActionBtn>
						<ActionBtn
							size="sm"
							type="danger-light"
							onClick={() => {
								confirm_delete_ref.current.show({
									title: "Delete clinic personnel",
									message:
										"Are you sure to delete this clinic personnel?",
									footer: ({ loadingBtn, setLoadingBtn }) => {
										return (
											<div className="flex items-center gap-4 w-full justify-end">
												<ActionBtn
													size="sm"
													type="primary-gradient"
													onClick={() => {
														confirm_delete_ref.current.hide();
													}}
												>
													No
												</ActionBtn>
												<ActionBtn
													size="sm"
													type="danger"
													loading={loadingBtn}
													onClick={() => {
														setLoadingBtn(true);
														deleteClinicPersonnel(
															data.id
														).then((res) => {
															setTimeout(() => {
																setLoadingBtn(
																	false
																);
																removeFromList(
																	data
																);
																toast.success(
																	"Clinic personnel deleted successfully!"
																);
															}, 200);
															confirm_delete_ref.current.hide();
														});
													}}
												>
													Confirm delete
												</ActionBtn>
											</div>
										);
									},
								});
							}}
						>
							<FlatIcon
								icon="rr-trash"
								className="text-lg mr-2"
							/>
							Delete
						</ActionBtn>
					</div>
				);
			},
		},
	];
	return (
		<LayoutContainer
			icon={<FontAwesomeIcon icon={faUsers} color="white" size={"2x"} />}
			title="Clinic personnel Management"
			subtitle="Add/Edit/Delete Clinic personnel here."
		>
			<CardContainer
				containerClassName={` border border- border-opacity-10 w-full`}
				header={{
					title: "Clinics personnel list data",
					children: (
						<div className="ml-auto flex items-center gap-3">
							<ActionBtn
								className="!no-underline !h-[42px]"
								size="sm"
								onClick={() => {
									clinic_personnel_form_modal.current.show();
								}}
							>
								<FlatIcon icon="rr-plus" className="mr-2" />
								<span className="!no-underline">
									Add clinic personnel
								</span>
							</ActionBtn>
							<TextInputField
								inputClassName=" pl-10"
								className="w-full lg:w-[320px]"
								onChange={(e) => {
									setKeyword(e.target.value);
								}}
								icon={
									<FlatIcon
										icon="rr-search"
										className="text-sm"
									/>
								}
								placeholder="Search"
							/>
						</div>
					),
				}}
				className="!p-0"
			>
				<div className="max-h-[calc(100vh-328px)] overflow-auto">
					<TableV2
						paginationClassName="px-4"
						columns={columns}
						direction={direction}
						setDirection={setDirection}
						pagination={false}
						loading={loading}
						column={column}
						setColumn={setColumn}
						data={
							keyword?.length > 0
								? localArraySearch(list, keyword)
								: list
						}
						onTableChange={(data) => {}}
						theadClassName={`sticky top-[-1px]`}
					/>
				</div>
			</CardContainer>
			<ClinicPersonnelFormModal
				ref={clinic_personnel_form_modal}
				addToList={addToList}
				updateInList={updateInList}
			/>

			<ConfirmationModal ref={confirm_delete_ref} />
		</LayoutContainer>
	);
};

export default PhoClinicPersonnel;
